/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import MaterialModal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import { useSpring, animated } from "react-spring";
import { CrossIcon } from "../Svg";

const useStyles = makeStyles(() => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "0",
  },
}));

const Fade = React.forwardRef((props, ref) => {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0, outline: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

const Modal = ({
  children,
  isOpen,
  close,
  hasCrossContainer = true,
  options = { showCloseButton: true },
  materialModalStyle,
}) => {
  const classes = useStyles();
  const renderCloseButton = () => (
    <button
      type="button"
      className="absolute cursor-pointer z-50 pt-3 outline-0-important"
      style={{ right: 10 }}
      onClick={close}
    >
      <CrossIcon hasCrossContainer={hasCrossContainer} />
    </button>
  );

  return (
    <div className="outline-none">
      <MaterialModal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={isOpen}
        onClose={close}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        style={materialModalStyle}
      >
        <Fade in={isOpen}>
          <div className="relative">
            {options.showCloseButton && renderCloseButton()}
            {children}
          </div>
        </Fade>
      </MaterialModal>
    </div>
  );
};

export default Modal;
